import React from 'react'
import { createPortal } from 'react-dom'

// Popup di conferma per Concludi/Rifiuta ordine (richiesta esplicita
// 2026-08-12): un'azione così com'era prima, un solo click sul bottone
// bastava a scrivere a DB (Concludi) o a mandare l'ordine in rifiuto,
// senza nessun passaggio intermedio che chiarisse le differenze tra le
// due — in particolare che Concludi è DEFINITIVO (nessuna modifica
// possibile dopo, vedi `locked` in OrderReview.jsx) mentre Rifiuta resta
// reversibile (finestra di revisione ancora aperta, vedi handleReopen in
// Dashboard.jsx/Coda.jsx). Stesso pattern visivo di ErrorModal in
// OrderReview.jsx (overlay + card centrata via createPortal, altrimenti
// l'overlay resterebbe intrappolato dentro gli `overflow:hidden` del
// layout) — click sul backdrop equivale ad Annulla.
export default function ConfirmActionModal({ open, title, message, confirmLabel, tone = 'primary', onConfirm, onCancel }) {
  if (!open) return null
  return createPortal(
    <div style={s.overlay} onClick={onCancel}>
      <div style={s.card} onClick={(e) => e.stopPropagation()}>
        <h3 style={s.title}>{title}</h3>
        <p style={s.message}>{message}</p>
        <div style={s.actions}>
          <button type="button" style={s.cancelBtn} onClick={onCancel}>Annulla</button>
          <button
            type="button"
            style={{ ...s.confirmBtn, ...(tone === 'danger' ? s.confirmBtnDanger : {}) }}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}

const s = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15,23,42,0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: 20,
  },
  card: {
    background: '#ffffff',
    borderRadius: 14,
    padding: '22px 24px',
    maxWidth: 420,
    width: '100%',
    boxShadow: '0 24px 60px -20px rgba(15,23,42,0.35)',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  title: {
    fontSize: 15.5,
    fontWeight: 600,
    color: 'var(--text)',
    margin: 0,
  },
  message: {
    fontSize: 13.5,
    lineHeight: 1.55,
    color: 'var(--text-2)',
    margin: 0,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
    marginTop: 8,
  },
  cancelBtn: {
    padding: '8px 16px',
    borderRadius: 8,
    border: '1px solid var(--hairline-strong)',
    background: '#FFFFFF',
    color: 'var(--text-2)',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'inherit',
    cursor: 'pointer',
  },
  confirmBtn: {
    padding: '8px 16px',
    borderRadius: 8,
    border: 'none',
    background: 'var(--jenia-violet)',
    color: '#FFFFFF',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'inherit',
    cursor: 'pointer',
  },
  confirmBtnDanger: {
    background: 'var(--danger)',
  },
}
